import api from './api';

export const userService = {
  listUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },

  activateUser: async (userId) => {
    const response = await api.patch(`/admin/users/${userId}/activate`);
    return response.data;
  },

  deactivateUser: async (userId) => {
    const response = await api.patch(`/admin/users/${userId}/deactivate`);
    return response.data;
  },

  promoteUser: async (userId) => {
    const response = await api.patch(`/admin/users/${userId}/promote`);
    return response.data;
  },

  demoteUser: async (userId) => {
    const response = await api.patch(`/admin/users/${userId}/demote`);
    return response.data;
  },

  getRegistrationSetting: async () => {
    const response = await api.get('/admin/settings/registration');
    return response.data;
  },

  setRegistrationSetting: async (enabled) => {
    const response = await api.put('/admin/settings/registration', { enabled });
    return response.data;
  },

  getRegistrationStatus: async () => {
    const response = await api.get('/auth/registration-status');
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },

  adminSetPassword: async (userId, newPassword) => {
    await api.patch(`/admin/users/${userId}/password`, { new_password: newPassword });
  },

  deleteUser: async (userId) => {
    await api.delete(`/admin/users/${userId}`);
  },
};
